<div class="user-alerts-cont">
  <div class="alert-list container">
    <ng-container *ngIf="isLoadingAlertList$ | async; else alertList">
      <ng-container *ngTemplateOutlet="placeholder"></ng-container>
    </ng-container>
  </div>
</div>

<app-swipe-up
  [height]="95"
  [showSwipeUp]="showSwipeUp"
  [title]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.MIN_TITLE' | transloco"
  [showHeader]="true"
  (toggleShowSwipeUp)="toggleConfirmForm()">
  <ng-container content>
    <ng-container *ngIf="showSwipeUp">
      <ng-container *ngTemplateOutlet="confirmForm"></ng-container>
    </ng-container>
  </ng-container>
</app-swipe-up>

<app-swipe-up
  [height]="95"
  [showSwipeUp]="notifyAlertCreated"
  (toggleShowSwipeUp)="toggleAlertCreated(hasAlertSelection)">
  <ng-container content>
    <ng-container *ngIf="notifyAlertCreated">
      <app-alert-created-edited-modal
        [isCreated]="isCreated"
        (toggleNotification)="toggleAlertCreated($event)">
      </app-alert-created-edited-modal>
    </ng-container>
  </ng-container>
</app-swipe-up>

<ng-template #confirmForm>
  <ng-container *ngIf="hasAlertSelection">
    <app-alert-form
      [directOnly]="alertSelected?.direct_only"
      [flightType]="flightType"
      [hiddenFlexDate]="true"
      [isUpdateForm]="isUpdateForm"
      [price]="alertSelected?.price_max"
      [departureDate]="alertSelectedDepartureDate"
      [arrivalDate]="alertSelectedArrivalDate"
      [arrivalPlace]="alertSelected?.arrival_name"
      (createAlert)="createAlertEvent($event)"
      (toggleConfirmFormEvent)="toggleConfirmForm()">
    </app-alert-form>
  </ng-container>
</ng-template>

<ng-template #placeholder>
  <div class="placeholder">
    <ng-container *ngFor="let i of [].constructor(placeholderQuantity)">
      <div class="alert-card-placeholder"></div>
    </ng-container>
  </div>
</ng-template>

<ng-template #alertList>
  <ng-container *ngIf="(hasAlertsEntities$ | async) === false; else alertCardList">
    <div class="container-not-alerts">
      <div class="content-info">
        <img class="img-empty-alerts" [src]="alertsEmptyImg | ImageCdn"/>
        <span class="title-empty"> {{ 'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.NO_ALERTS' | transloco }}</span>
        <span class="message-empty">{{ 'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.EMPTY_LIST' | transloco }}</span>
      </div>
    </div>
  </ng-container>
  <div class="userAlerts__button" *ngIf="isMobile$ | async">
    <app-fixed-surface
      [surface]="surface">
      <div class="userAlerts__button-message">
        <app-ds-typography
          [size]="fontSize.XXS"
          [fontFamily]="fontFamily.SemiBold"
          [color]="fontColor.Primary"
          [text]="'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.CREATE_ALERT_QUESTION'| transloco">
        </app-ds-typography>
      </div>
      <app-ds-button
        [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.CREATE_ALERT'| transloco }"
        (clickEvent)="onRedirectCreate()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</ng-template>

<ng-template #alertCardList>
  <ng-container *ngFor="let alert of alertsEntities$ | async | activeAlerts; trackBy: trackBy">
    <app-alert-card
      [alert]="alert"
      (editAlert)="editAlert($event)"
      (openFlights)="openFlights($event)"
      (deleteAlert)="removeAlert($event)">
    </app-alert-card>
  </ng-container>
</ng-template>

